<div class="auth-layout">
  <div class="auth-container">
    <div class="auth-container__page">
      <img
        [src]="logo()"
        alt="Conntap"
        class="auth-container__logo"
      />
      <router-outlet />
    </div>

    <div class="auth-container__poster">
      <span>
        {{ 'layouts.auth-layout.poster.label' | translate }}
      </span>

      <img
        loading="lazy"
        src="assets/images/icons/dots.svg"
        alt="Dots"
        class="dots top"
      />

      <img
        loading="lazy"
        src="assets/images/auth-poster.svg"
        alt="Login illustration"
      />

      <img
        loading="lazy"
        src="assets/images/icons/dots.svg"
        alt="Dots"
        class="dots bottom"
      />
    </div>
  </div>
</div>
